import React from "react"
import { Box, makeStyles, Tooltip, Typography } from "@material-ui/core";
import BtnSecHoverComponent from "./BtnSecHoverComponent";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
	btnsCont: {
		display: 'flex',
		justifyContent: 'space-between',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column'
		},
	},
	btn: {
		margin: theme.spacing(1),
		padding: '12px 24px'
	},
	hr: {
		width: 80,
		marginLeft: 0,
		background: theme.palette.secondary.main,
		border: 'none',
		height: 3,
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(6),
		[theme.breakpoints.down('md')]: {
			marginBottom: theme.spacing(4),
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(1),

		},

	},
	contentBox: {
		marginBottom: theme.spacing(8),
		[theme.breakpoints.down('md')]: {
			marginBottom: theme.spacing(6),
		},
		[theme.breakpoints.down('sm')]: {
			marginBottom: theme.spacing(4),
		},
	},
	title: {
		fontWeight: 550,
		fontSize: 18,
	},
	custom: {
		color: theme.palette.primary.main,
		marginTop: theme.spacing(2),
		textAlign: 'center',
		cursor: 'pointer',
	}
}));

const CookieContentComponent = ({
	title,
	tabValue,
	value,
	children,
	showCustomTitle,
	secondBtn = '',
	handleAccept = () => { },
	handleCustom = () => { },
	handleSecondBtn = () => { }
}) => {
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<Box
			role="tabpanel"
			hidden={tabValue !== value}
		>
			<Box className={classes.titleBox}>
				<Typography variant='h6' className={classes.title}>{title}</Typography>
				<hr className={classes.hr} />
			</Box>
			<Box className={classes.contentBox}>
				{children}
			</Box>
			<section>
				<Box className={classes.btnsCont}>
						<BtnSecHoverComponent size='small' variant='outlined' color='default' className={classes.btn} onClick={handleSecondBtn}>
							{secondBtn}
						</BtnSecHoverComponent>	
					<Tooltip title={t('tooltip.cookies_allow_all')}>
						<BtnSecHoverComponent size='small' variant='contained' color='secondary' className={classes.btn} onClick={handleAccept}>
							{t('buttons.cookies_allow_all')}
						</BtnSecHoverComponent>
					</Tooltip>
				</Box>
				{
					showCustomTitle 
					? 
					<Tooltip title={t('tooltip.customize')}>
						<Typography className={classes.custom} onClick={handleCustom}>{t('buttons.read_about_cookies')}</Typography>
						 </Tooltip> 
							: null }
			</section>
		</Box>

	);
};

export default React.memo(CookieContentComponent);